import React, { forwardRef } from "react";
import CodeEditorPanel from "../../../code-editor-panel";

const CodeEditor = forwardRef(({ workspaceId, workspace }, ref) => {
  return (
    <div className="h-full overflow-auto">
      <CodeEditorPanel
        ref={ref}
        workspaceId={workspaceId}
        projectPath={workspace?.directory_path || "/workspace"}
      />
    </div>
  );
});

CodeEditor.displayName = "CodeEditor";

export default CodeEditor;
